import React from "react";

import { processStatisticsPercentage, renderStatistics } from "@/modules/statistics";
import { IGameStatisticsClass } from "@/types/StatisticsTypes";
import { IGenericHistoryType } from "@/types/GameHistoryTypes";

//note: use this.props.langdata to get language information
export default class M13 extends IGameStatisticsClass {
	constructor() {
		super(null);

		this.filtrate = function(history: IGenericHistoryType[], filter: string) {
			const historyCopy = history.slice(0).filter(item => +item.angka !== 8);
			const total = historyCopy.length;
	
			switch (filter) {
				case "small-big":
					let smalls = 0;
					historyCopy.forEach(item => {
						const angka = Number(item.angka);
						if (angka < 8)
							++smalls;
					});
					const bigs = total - smalls;
					
					this.statisticsArray.top.push(...[
						<div key="m13gst_0" className="sl-roadmap-circle blue-circle">S</div>,
						<div key="m13gst_1" className="sl-roadmap-circle red-circle">B</div>
					]);
					
					this.statisticsArray.bottom.push(...[
						processStatisticsPercentage("m13gsb_0", smalls, total),
						processStatisticsPercentage("m13gsb_1", bigs, total)
					]);
				break;
				default: break;
			}
		};
	}

	render() {
		return renderStatistics(this);
	}
}
